import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setDataLoading, setSearchResult, setSearchResultError } from ".";
import { getConfig } from "plugins/config-loader";
import { AuxNotificationStyleEnum, AuxNotificationToastTypeEnum } from "@blk/aladdin-web-components";
import { addNotification } from "store/notification";
import { language } from "language/default";
export const documentLibrarymoduleName = "documentLibrary";
export const prepareHeaders = (headers, api) => {
    const state = api.getState();
    const extra = api.extra;
    const token = extra?.getStateValue(state, "accessToken");
    const connectionId = extra?.getStateValue(state, "connectionId");
    if (token) {
        headers.set("authorization", `Bearer ${token}`);
    }
    if (connectionId) {
        headers.set("Connection-Id", connectionId);
    }
    return headers;
};
export const onSearchQueryStarted = async (arg, thisApi) => {
    const { dispatch, queryFulfilled } = thisApi;
    try {
        const { data } = await queryFulfilled;
        dispatch(setSearchResult(data.resource));
    }
    catch {
        dispatch(setSearchResultError());
    }
};
export const onCheckVaultAccessStarted = async (_request, queryApi) => {
    try {
        await queryApi.queryFulfilled;
    }
    catch {
        queryApi.dispatch(addNotification({
            id: Date.now().toString(),
            message: language.en.notes.documents.uploadFailedConfigError,
            notificationStyle: AuxNotificationStyleEnum.ERROR,
            showMessageCount: false,
            toastTimeout: 3000,
            toastType: AuxNotificationToastTypeEnum.PERSISTENT
        }));
    }
};
export const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: `${getConfig("REACT_APP_CLICKTHROUGH_BACKEND_BASE_URL")}`,
        prepareHeaders
    }),
    endpoints: (builder) => ({
        checkVaultAccess: builder.query({
            keepUnusedDataFor: 0,
            onQueryStarted: (_request, queryApi) => onCheckVaultAccessStarted(_request, queryApi),
            query: () => ({ method: "GET", url: "/documents/vault-access" })
        }),
        getDownloadMultipleDocuments: builder.query({
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    await queryFulfilled;
                }
                catch {
                    // Ignore errors obtaining operation id
                }
            },
            query: (request) => ({
                body: request,
                method: "POST",
                url: "downloadmultiple"
            })
        }),
        getDownloads: builder.query({
            async onQueryStarted(arg, { queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    if (data.contentUrl) {
                        setDataLoading(false);
                    }
                }
                catch {
                    // Ignore errors obtaining operation id
                }
            },
            query: (request) => ({
                body: request,
                method: "POST",
                url: "downloads"
            })
        }),
        getEntities: builder.query({
            query: (request) => ({
                body: request,
                method: "POST",
                url: "filters"
            }),
            transformResponse: (response) => response
        }),
        getSearchDocuments: builder.query({
            onQueryStarted: onSearchQueryStarted,
            query: (request) => ({
                body: request,
                method: "POST",
                url: "/search"
            }),
            transformResponse: (response) => ({
                pageToken: response.pageToken,
                resource: response.resource,
                tenantTotalCount: response.tenantTotalCount,
                totalCount: response.totalCount
            })
        })
    }),
    reducerPath: `${documentLibrarymoduleName}.api`,
    tagTypes: ["Search", "Download"]
});
export const { endpoints: { getSearchDocuments }, useGetSearchDocumentsQuery, useCheckVaultAccessQuery, useLazyGetDownloadsQuery, useLazyGetDownloadMultipleDocumentsQuery, useGetEntitiesQuery, middleware: documentLibraryMiddleware, reducer: documentLibraryReducers, reducerPath: documentLibraryReducersPath } = api;
